<template>
  <div class="p-3">
    <div id="pop-up" v-if="loading == true">
      <div class="">
        <b-spinner
          variant="primary"
          style="width: 4rem; height: 4rem"
          label=""
        ></b-spinner>
      </div>
    </div>
    <div class="createQuestion">
      <div class="create-topic-list">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <p class="pr-2 text-nowrap">
              {{ $t("group_topic_list.label.category") }}:
            </p>
            <multiselect
              v-model="cateSelected"
              :close-on-select="true"
              :clear-on-select="false"
              label="category"
              :multiple="true"
              :options="category"
              :placeholder="$t('group_topic_list.label.select_and_select_one')"
              track-by="category"
              :hide-selected="true"
              :max-height="150"
              class=""
              @select="checkCategoryPermission"
              >
            </multiselect>
          </div>
          <div class="d-flex align-items-center header-create-topic">
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("group_topic_list.label.type") }}:</p>
              <select class="createQuestion-dropdown" @change="typeOfQuestion">
                <option v-for="num in typeOfQuestions" :key="num.id" value="">
                  {{ num }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">
                {{ $t("group_topic_list.label.difficulty_title") }}:
              </p>
              <select
                class="createQuestion-dropdown"
                @change="difficultyOfQuestion"
              >
                <option v-for="num in difficulty" :key="num.id" value="">
                  {{ num.difficulty }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row justify-content-around">
          <div class="col left-embed p-0">
            <!-- //embed video/image -->
            <div
              class="d-flex flex-column align-items-center embed-image-video"
              style="height: unset"
            >
              <ion-icon
                style="font-size: 60px; margin-bottom: 10px"
                name="cloud-upload-outline"
                v-if="!imageUpload && !file && !embedUpload"
              ></ion-icon>
              <label
                v-if="!imageUpload && !file && !embedUpload"
                class="label-uploadImage"
                for="uploadImage"
                style="white-space: nowrap"
              >
                {{ $t("group_topic_list.label.select_file") }}
              </label>
              <input
                v-if="!imageUpload && !file && !embedUpload"
                type="file"
                @change="handleFileUpload"
                class=""
                id="uploadImage"
              />
              <div v-if="imageUpload || file" id="preview1" class="">
                <img v-if="imageUpload" :src="imageUpload" />
                <video
                  style="width: 500px; height: 100%"
                  v-if="file"
                  :src="file"
                  controls
                  id="video-preview"
                ></video>
                <button @click="removeFile">X</button>
              </div>
              <button id="removeEmbed" v-if="embedUpload" @click="removeEmbed" style="right: 0;">
                X
              </button>
              <div id="embedUpload"></div>
              <div
                v-if="!imageUpload && !file"
                class="d-flex justify-content-between embed-image my-2"
              >
                <input
                  v-model="form.embed_image_video"
                  type="text"
                  v-if="!embedUpload"
                />
                <button @click="embed()" v-if="!embedUpload">
                  {{ $t("question_list.label.embed_image") }}
                </button>
              </div>
            </div>
          </div>
          <div class="col">
            <div
              v-if="embedAudio === ''"
              class="d-flex align-items-center justify-content-between mb-4"
            >
              <div class="upload-audio">
                <button
                  class="upload-audio-button"
                  for="upload-audio-input"
                  type="button"
                >
                  <b-icon
                    icon="music-note-beamed"
                    font-scale="1.5"
                    style="margin-right: 5px"
                    variant="danger"
                  ></b-icon>
                  <label style="white-space: nowrap" for="upload-audio-input">{{
                    $t("question_list.label.audio")
                  }}</label>
                </button>
                <b-form-file
                  v-show="audioUpload == ''"
                  accept="audio/*"
                  v-model="fileCreateTopic"
                  @change="handleAudioUpload($event)"
                  class="pr-1"
                  id="upload-audio-input"
                ></b-form-file>
              </div>
              <audio
                id="form"
                :src="audioUpload"
                controls
                v-show="audioUpload != ''"
              />
              <ion-icon
                @click="removeAudio"
                v-show="audioUpload != ''"
                name="close-circle-outline"
                style="font-size: 40px"
              ></ion-icon>
            </div>
            <div v-if="audioUpload == ''" class="embed-audio d-flex flex-row">
              <b-button @click="audioEmbedLeft">
                <b-icon
                  icon="box-arrow-up"
                  font-scale="1.2"
                  variant="success"
                ></b-icon>
                <span>{{ $t("question_list.label.embed_video_audio") }}</span>
              </b-button>
              <!--                            8-->
              <input
                :placeholder="
                  $t('question_list.label.embed_video_audio_placeHolder')
                "
                v-model="form.embed_audio"
                type="text"
                id="embed_audio_link"
              />
              <ion-icon
                class="remove-embed-audio-btn-topic"
                @click="removeEmbedAudio"
                v-show="embedAudio != ''"
                name="close-circle-outline"
              ></ion-icon>
            </div>
            <div id="audio_embed_view"></div>
            <div class="question-input__textArena">
              <textarea
                v-model="form.title"
                @keyup="charCount()"
                name=""
                id=""
                class=""
                rows="3"
                maxlength="1500"
                :placeholder="
                  $t('group_topic_list.placeholder.typing_for_question')
                "
              ></textarea>
              <!-- <span>{{ totalCharacter }} / 1500</span> -->
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3 float-right">
        <b-button @click="hideModal" variant="danger">{{
          $t("group_topic_list.button.cancel")
        }}</b-button>
        <b-button
          v-if="disable == true"
          @click="CreateTopics()"
          style="margin-left: 1rem"
          variant="primary"
          >{{ $t("group_topic_list.button.save") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: { Multiselect },
  data() {
    return {
      loading: false,
      disable: true,
      embedAudio: "",
      isText: null,
      fileCreateTopic: null,
      imageReRender: 0,
      cateSelected: [],
      defaultNumberAnswer: 4,
      typeOfQuestions: ["Listening", "Writing", "Reading", "Speaking"],
      alphabetAnswerSelected: 0,
      typeOfAnswers: ["Number", "Alphabet"],
      statusSelected: 1,
      answerOptionOfQuestions: ["One choice", "Multiple choice"],
      numberAnswerOfQuestions: [2, 3, 4, 5, 6],
      valueTypeOfAnswers: [
        [1, 2, 3, 4, 5, 6],
        ["A", "B", "C", "D", "E", "F"]
      ],
      valueTypeOfAnswer: [1, 2, 3, 4],
      imageUpload: "",
      embedUpload: "",
      audioUpload: "",
      totalCharacter: 0,
      answerUpload: [],
      correctAnswer: [],
      file: "",
      fillterData: {
        search: "",
        page: 1,
        selected: {
          id: null,
          group_topic: "",
          teacher: "",
          category: null,
          difficulty: "",
          typeTopic: "",
          status: "",
          paginate: 20
        }
      },
      form: {
        title: "",
        type: "Listening",
        status: "Active",
        score: "",
        difficulty: "Easy",
        category: [],
        explain: "explain",
        image_path: "",
        video_path: "",
        embed_image_video: "",
        audio_path: "",
        embed_audio: "",
        answer_option: "One choice",
        answer: [],
        image: [],
        answer_text: [],
        number_answer: 4
      },
      selectedTypeAnswer: "Alphabet",
      tags: []
    };
  },
  computed: {
    ...mapState("config", ["category", "difficulty"]),
    ...mapState("question", ["explain", "explain_path"]),
    ...mapState("auth", ["user"]),
    ...mapGetters({
      createTopicRes: "topics/createTopicRes",
      getTopicListRes: "topics/topicListRes"
    }),

    categoryIdsAllow() {
      return this.user?.category_ids_apply || "";
    }
  },

  methods: {
    audioEmbedLeft() {
      if (!this.form.embed_audio) {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_43"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
      if (
        this.form.embed_audio.includes("<iframe") &&
        this.form.embed_audio.includes("></iframe>") &&
        this.form.embed_audio.includes("src=")
      ) {
        this.embedAudio = this.form.embed_audio;
        document.getElementById("audio_embed_view").innerHTML = this.embedAudio;
      } else {
        this.$bvToast.toast(this.$t("questions_create.message.data_invalid"), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    async CreateTopics() {
      this.loading = true;
      this.disable = false;
      let data = new FormData();

      for (let i = 0; i < this.cateSelected.length; i++) {
        this.form.category[i] = this.cateSelected[i]["category"];
      }

      if (!this.form.category[0]) {
        this.$root.toast(
          this.$t(`msg["E_UC2.2_18"]`),
          "danger",
          this.$t(`msg["E_UC2.1_23"]`)
        );
        this.disable = true;
        this.loading = false;
        return;
      }
      if (!this.form.title) {
        this.$root.toast(
          this.$t(`msg["E_UC2.2_18"]`),
          "danger",
          this.$t(`msg["E_UC2.2_06"]`)
        );
        this.disable = true;
        this.loading = false;
        return;
      }

      this.form.image.map(photo => data.append("image[]", photo, photo.name));
      data.append("type", this.form.type);
      data.append("title", this.form.title);
      data.append(
        "category",
        JSON.stringify(this.form.category).replace(/\\(.)/gm, "$1")
      );
      data.append("difficulty", this.form.difficulty);
      data.append("image_path", this.form.image_path);
      data.append("video_path", this.form.video_path);
      data.append("embed_path", this.form.embed_image_video);
      data.append("audio_path", this.form.audio_path);
      data.append("embed_audio", this.form.embed_audio);

      this.$root.$loading.start();
      await this.$store.dispatch("topics/createTopic", data);
      this.$root.$loading.finish();
      if (this.$store.state.topics.createTopicRes.status === 200) {
        await this.$store.dispatch("topics/getTopicTest", this.fillterData);

        for (let i = 0; i < this.getTopicListRes.length; i++) {
          let getTime = this.getTopicListRes[i].updated_at;
          let getDay = new Date(getTime).getUTCDate();
          let getMonth = new Date(getTime).getUTCMonth() + 1;
          let getYear = new Date(getTime).getUTCFullYear();
          this.getTopicListRes[i].updated_at =
            getDay + "/" + getMonth + "/" + getYear;
        }
        this.$bvModal.hide("modal-create-topic");
        this.$root.toast(
          this.$t(`msg["C_UC2.2_2"]`),
          "success",
          this.$t(`msg["C_UC2.2_2"]`)
        );
        this.form.title = "";
        this.form.status = "";
        this.form.score = "";
        this.form.difficulty = "";
        this.form.explain = "";
        this.form.image_path = "";
        this.form.video_path = "";
        this.form.embed_image_video = "";
        this.form.audio_path = "";
        this.form.embed_audio = "";
        this.form.image = "";
        this.loading = false;
      } else {
        const apiRes = this.$store.state.topics.createTopicRes;
        const errors =
          apiRes?.errors?.title ||
         { message: apiRes?.message } || "";
        const errorFields = Object.values(errors);

        this.$root.toast(
          this.$t('msg["E_UC2.2_18"]'),
          "danger",
          this.$t(`msg["${errorFields}"]`)
        );
        this.disable = true;
        this.loading = false;
      }
    },
    hideModal() {
      this.$bvModal.hide("modal-create-topic");
    },

    // lay dap an dung
    getMultiCorrectAnswer(index) {
      this.form.answer[index]["ans_id"] = index + 1;

      if (this.form.answer[index]["isCorrect"] === "true") {
        this.form.answer[index]["isCorrect"] = "false";
      } else {
        this.form.answer[index]["isCorrect"] = "true";
      }
    },

    getCorrectAnswer(index) {
      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        const reqData = { ans_id: i + 1, isCorrect: "false" };
        this.form.answer.push(reqData);
      }
      this.form.answer[index]["ans_id"] = index + 1;
      this.form.answer[index]["isCorrect"] = "true";
    },

    // so luong cau tra loi
    numberAnswerOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.number_answer = parseInt(
          e.target.options[e.target.options.selectedIndex].outerText
        );
      }
      this.valueTypeOfAnswer = [];
      if (this.alphabetAnswerSelected == 0) {
        for (let i = 0; i < this.form.number_answer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[0][i];
          this.imageReRender++;
        }
      } else {
        for (let i = 0; i < this.form.number_answer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[1][i];
          this.imageReRender++;
        }
      }

      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        const reqData = { ans_id: i + 1, isCorrect: "false" };
        this.form.answer.push(reqData);
      }
      if (this.form.answer_option == "Multiple choice") {
        document.getElementById("checkbox").checked = false;
      } else {
        document.getElementById("radio").checked = false;
      }
    },
    // the loai cau hoi
    typeOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.type =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },
    // alphabet cau hoi
    alphabetOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.alphabetAnswerSelected = parseInt([
          e.target.options.selectedIndex
        ]);
      }
      if (this.alphabetAnswerSelected == 0) {
        for (let i = 0; i < this.defaultNumberAnswer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[0][i];
          this.imageReRender++;
        }
      } else {
        for (let i = 0; i < this.defaultNumberAnswer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[1][i];
          this.imageReRender++;
        }
      }
    },
    // trang thai cau hoi
    statusOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        if (
          (this.form.status =
            e.target.options[e.target.options.selectedIndex].outerText)
        );
      }
    },
    // do kho cau hoi
    difficultyOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.difficulty =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },
    // so luong cau tra loi chinh xac
    manyAnswerOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.answer_option =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        const reqData = { ans_id: i + 1, isCorrect: "false" };
        this.form.answer.push(reqData);
      }
    },
    charCount: function() {
      this.totalCharacter = this.form.title.length;
      if (this.totalCharacter == 1500) {
        this.$root.toast(
          this.$t("difficulty.notice"),
          "danger",
          this.$t(`msg["E_UC2.2_34"]`)
        );
        return;
      }
    },
    handleImageUpload(e) {
      const img = e.target.files[0];
      this.form.image_path = img;
      this.imageUpload = URL.createObjectURL(img);
    },
    handleAnswerUpload(e, index) {
      const img = e.target.files[0];
      this.form.image.push(img);
      // this.form.image[index] = img;
      this.answerUpload[index] = URL.createObjectURL(img);
      this.imageReRender += 1;
    },
    previewAudio() {
      let audio = document.getElementById("audio-preview");
      let reader = new FileReader();

      reader.readAsDataURL(this.file);
      reader.addEventListener("load", function() {
        audio.src = reader.result;
      });
    },
    handleAudioUpload(event) {
      if (event.target.files[0].size / 1048576 > 10) {
          this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
          });
        return;
        }
      this.audioUpload = event.target.files[0];
      this.form.audio_path = this.audioUpload;

      this.audioUpload = URL.createObjectURL(this.audioUpload);
    },
    handleFileUpload(e) {
      // check validate
      let fileUpload = e.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];

      if (
        typeOfFile === "mp4" ||
        typeOfFile === "jpg" ||
        typeOfFile === "jpeg" ||
        typeOfFile === "png"
      ) {
        if (e.target.files[0].size / 1048576 > 10) {
          this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
          });
        } else if (typeOfFile === "mp4") {
          this.file = e.target.files[0];
          this.form.video_path = this.file;
          this.file = URL.createObjectURL(this.file);
        } else {
          const img = e.target.files[0];
          this.form.image_path = img;
          this.imageUpload = URL.createObjectURL(img);
        }
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    embed() {
      if (!this.form.embed_image_video) {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_43"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
      if (
        this.form.embed_image_video.includes("https://") ||
        this.form.embed_image_video.includes("http://") ||
        this.form.embed_image_video.includes("<iframe")
      ) {
        this.embedUpload = this.form.embed_image_video;
        document.getElementById("embedUpload").innerHTML =
          '<embed width="500" height="250" style="object-fit: contain" src="' +
          this.embedUpload +
          '"  frameborder="0"   allowfullscreen></embed>';
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    removeFile: function() {
      this.imageUpload = "";
      this.form.image_path = "";
      this.file = "";
      this.form.video_path = "";
    },
    removeEmbed: function() {
      this.embedUpload = "";
      this.form.embed_image_video = "";
      document.getElementById("embedUpload").innerHTML = "";
    },
    removeImage: function() {
      this.imageUpload = "";
      this.form.image_path = "";
    },
    removeAudio: function() {
      this.form.audio_path = "";
      this.audioUpload = "";
      document.getElementById("upload-audio-input").value = null;
    },
    removeEmbedAudio: function() {
      this.form.embed_audio = "";
      this.embedAudio = "";
      document.getElementById("embed_audio_link").value = null;
      document.getElementById("audio_embed_view").innerHTML = null;
    },
    removeAnswerImage: function(index) {
      this.answerUpload[index] = "";
      this.imageReRender += 1;
    },
    backToListQuestion() {
      this.$root.$loading.start();
      this.$router.push({ name: "QuestionList" });
      this.$root.$loading.finish();
    },
    checkCategoryPermission(item) {
      // Không phải tài khoản giáo viên B2B thì không cần check quyền category
      const businessId = Number(this.user?.business_id || 0);
      if (businessId <= 0) {
          return;
      }
      // ENd check tài khoản giáo viên
      const allowedIds = this.categoryIdsAllow
        .split(",")
        .map(id => String(id).trim())
        .filter(Boolean);

      const categoryId = String(item.id);

      if (!allowedIds.includes(categoryId)) {
        this.$nextTick(() => {
          this.cateSelected = this.cateSelected.filter(
            cate => String(cate.id) !== categoryId
          );
        });

        this.$root.toast(
          this.$t(`msg["title_notification"]`),
          "danger",
          this.$t(`msg["content_noti_topic"]`),
        );
      }
    }
  },
  async created() {
    this.form.answer = [];
    for (let i = 0; i < this.defaultNumberAnswer; i++) {
      const reqData = { ans_id: i + 1, isCorrect: "false" };
      this.form.answer.push(reqData);
    }
    await this.$root.$loading.start();
    await this.$store.dispatch("config/getCategory");

    this.$root.$loading.finish();
  }
};
</script>

<style>
@import "../../assets/scss/Questions.scss";

* {
  font-size: 15px;
}

.label-uploadImage {
  background: #0ae8cd;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  cursor: pointer;
  padding: 16px 91px;
}

#uploadImage {
  display: none;
}

.left-embed {
}

.embed-image {
  width: 63%;
}

.embed-image button {
  width: 100%;
}

.embed-image-video {
  height: 100%;
  justify-content: center;
  margin-right: 10px;
}

.embed-image input {
  padding: 10px 10px;
  background: #e5eaff;
  border-radius: 10px;
  border: none;
}

.embed-image button {
  background: #0ae8cd;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  border: none;
  margin-left: 10px;
}

/*#preview1 {*/
/*  height: 250px;*/
/*  width: 500px;*/
/*  position: relative;*/
/*}*/

#preview1 img {
  width: 50%;
  height: 100%;
  object-fit: contain;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

#preview1 button {
    border: none;
    padding: 10px;
    border-radius: 10px;
    margin-left: 20px
  /*!*position: absolute;*!*/
  /*!*right: 0px;*!*/
  /*z-index: 1;*/
  /*top: -10px;*/
  /*border-radius: 50px;*/
  /*width: 30px;*/
}

.upload-audio {
  width: 40%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.upload-audio-button label {
  margin-bottom: 0px;
  padding: 10px;
}

.upload-audio .upload-audio-button {
  display: flex;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  font-size: 15px;
  align-items: center;
  position: relative;
  justify-content: center;
}

.upload-audio #upload-audio-input__BV_file_outer_ {
  display: none;
}

.upload-audio #upload-audio-input,
.upload-audio .custom-file-label {
  display: none;
}

#audio-preview {
  padding: 10px;
  width: 100%;
  align-items: center;
}

.embed-audio {
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.embed-audio button {
  width: 27%;
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  color: black;
}

.embed-audio input {
  width: 72%;
  background: #e5eaff;
  border-radius: 3px;
  border: none;
  padding: 5px 10px;
}

.answer-options {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}

.answer-options p {
  width: 27%;
  margin-right: 6px;
}

.answer-options select {
  background: #ffffff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  padding: 8px 18px;
}

.question-input__textArena {
  position: relative;
}

.question-input__textArena textarea {
  width: 100%;
  background: #e5eaff;
  border-radius: 10px;
  border: none;
  padding: 20px;
  font-size: 15px;
}

.question-input__textArena span {
  position: absolute;
  width: max-content;
  bottom: 10px;
  right: 10px;
  font-size: 15px;
}

.btn-explanation {
  background: #ffbf00;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
  border: none;
  padding: 11px 33px;
}

.checked,
.checkboxInvisible {
  position: absolute;
  right: 0%;
  top: 0%;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  z-index: 999;
}

.answerQuestion {
  position: relative;
  border: 1px solid black;
  width: 49%;
  border: 1px solid #c4c4c4;
  border-radius: 8px;
  padding: 10px;
  height: fit-content;
}

.answerQuestion div button {
  border: none;
  padding: 10px;
  border-radius: 10px;
  margin-left: 20px;
}

textarea {
  border: none;
  outline: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  overflow-y: auto;
  resize: none; /*remove the resize handle on the bottom right*/
}

.option-question {
  display: flex;
  justify-content: space-between;
  text-align: center;
  align-items: center;
}

.tesst1 {
  display: flex;
}

.answerQuestion img {
  max-height: 100px;
  width: 50%;
  -o-object-fit: contain;
  object-fit: contain;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.header-create-topic {
  width: 70%;
}

.create-topic-list .justify-content-around {
  justify-content: space-around !important;
  background: #ffffff;
  /* box-shadow: 2px 2px 26px rgb(0 0 0 / 25%); */
  border-radius: 17px;
  padding: 8px 6px 10px 0px;
}

.nameAudio-main {
  width: 99%;
  padding-left: 10px;
}

.nameAudio-detail {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.createQuestion .modal-content {
}

iframe {
  margin-top: 0px;
}
</style>
